/**
 * Returns true when the viewer should drop zoom and scroll animations in favor
 * of instant transforms.
 *
 * Targets touch devices (tablets/phones), users requesting reduced motion, and
 * Safari where composite layer animation over large SVG overlays causes lag.
 */
export function preferInstantViewerMotion(): boolean {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false
  }

  const matchesMedia = (query: string): boolean => {
    return (
      typeof window.matchMedia === 'function' &&
      window.matchMedia(query).matches
    )
  }

  if (
    matchesMedia('(pointer: coarse)') ||
    matchesMedia('(prefers-reduced-motion: reduce)') ||
    (typeof navigator.maxTouchPoints === 'number' &&
      navigator.maxTouchPoints > 0)
  ) {
    return true
  }

  const ua = navigator.userAgent
  return /Safari/i.test(ua) && !/Chrome|Chromium|CriOS|Edg|Android/i.test(ua)
}

export function viewerZoomAnimationMs(): number {
  return preferInstantViewerMotion() ? 0 : 200
}

export function viewerFrameAnimationMs(): number {
  return preferInstantViewerMotion() ? 0 : 300
}
